<div class="p-3 md:p-32 bg-lightest md:pb-0 pb-28 overflow-y-auto h-full w-full">
  <app-contact-info-note
    [agreementTypes]="agreementTypes"
    (returnToPolicy)="goBackToPolicy()"></app-contact-info-note>

  <div class="bg-white rounded-lg shadow-none border border-light md:p-4 w-11/12 mx-auto pb-5 md:mb-7">
    <div class="font-app-bold p-4">
      {{ "contactUsForm.title" | translate }}
    </div>
    <div class="p-4 -mt-4">
      <form
        [formGroup]="contactForm"
        class="text-sm text-dark">
        <div class="md:grid md:grid-cols-2 md:gap-4">
          <div class="w-full md:pr-6">
            <app-contact-reference-request
              [memberAgreements]="memberAgreements"
              [requestNatureOptions]="requestNatureOptions"
              [form]="contactForm"
              (referenceChange)="onSelectReference()"
              (requestNatureChange)="onSelectNatureDemand()"></app-contact-reference-request>

            <app-termination-section
              [requestNature]="requestNature"
              [reasonOptions]="reasonOptions"
              [form]="contactForm"
              (terminationReasonSelected)="onSelectTerminationReason()"></app-termination-section>

            <app-attestation-details
              [form]="contactForm"
              [attestationOptions]="attestationOptions"
              [isGeneratedOptions]="isGeneratedOptions"
              [documentTypes]="documentTypes"></app-attestation-details>

            <app-file-upload-section
              class="hidden md:block"
              [uploadedFiles]="uploadedFiles"
              [enableDocumentUpload]="enableDocumentUpload"
              [showMandatoryFileUploadMessage]="showMandatoryFileUploadMessage"
              [documentTypes]="documentTypes"
              [requestNature]="requestNature"
              [documentTypesToDisplay]="documentTypesToDisplay"
              (filesChanged)="onFilesChanged($event)"></app-file-upload-section>
          </div>
          <div>
            <div class="md:flex md:flex-col-reverse md:justify-end">
              <app-termination-date
                [form]="contactForm"
                [minTerminationDate]="minTerminationDate"
                [maxTerminationDate]="maxTerminationDate"></app-termination-date>
              <app-comment-section
                [form]="contactForm"
                [spanMandatoryComment]="spanMandatoryComment"></app-comment-section>
              <div>
                <app-file-upload-section
                  class="md:hidden"
                  [uploadedFiles]="uploadedFiles"
                  [enableDocumentUpload]="enableDocumentUpload"
                  [showMandatoryFileUploadMessage]="showMandatoryFileUploadMessage"
                  [documentTypes]="documentTypes"
                  [requestNature]="requestNature"
                  [documentTypesToDisplay]="documentTypesToDisplay"
                  (filesChanged)="onFilesChanged($event)"></app-file-upload-section>
              </div>
            </div>
            <div>
              <div class="w-full">
                <div class="mt-4 mb-4 text-black">
                  {{ "contactUsForm.advisorInfo.message" | translate }}
                  <span class="font-bold">{{ officeHours }}</span>
                  {{ "contactUsForm.advisorInfo.to" | translate }}
                  <span class="font-bold">{{ advisorPhoneNumber }}</span>
                </div>
              </div>
            </div>
          </div>
          <app-action-buttons
            [contactForm]="contactForm"
            [enableSubmit]="enableSubmit"
            [memberAgreements]="memberAgreements"
            [requestNatureOptions]="requestNatureOptions"
            [reasonOptions]="reasonOptions"
            (showTerminationConfirmationPopup)="handleTerminationConfirmation($event)"
            (handleFormSubmit)="onSubmit()"
            (handleFormCancel)="closeContactUsPage()"></app-action-buttons>
        </div>
      </form>

      <app-request-confirmation-popup
        *ngIf="showTerminationConfirmationPopup"
        [confirmationSummary]="confirmationSummary"
        (dialogEmitter)="handleTerminationConfirmationPopup($event)">
      </app-request-confirmation-popup>

      <app-popup-dialog
        *ngIf="showSentRequestPopup"
        [visibleDialog]="showSentRequestPopup"
        [saveMessage]="sentRequestMessage"
        [acceptLabel]="'requestSent.closeButton' | translate"
        [showRejectButton]="false"
        (dialogEmitter)="onCloseSentRequestPopup()">
      </app-popup-dialog>
    </div>
  </div>
</div>

